<template>
  <a-card v-if="pageLoading">
    <a-spin
      tip="Your document is being processed, do not leave this page!"
      :spinning="pageLoading"
    />
  </a-card>
  <div v-else>
    <div
      :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'"
      v-if="pageLoading === false"
    >
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
          <a-card :loading="pageLoading" class="margin-bottom">
            <div slot="title">
              <div>Manifest Bailout Fund Manifest</div>
              <small class="m-display-block m-text-small">{{
                data.header.no_lkb
              }}</small>
            </div>
            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>No PP/PD</span>
                  <span class="m-list-desc">{{ data.header.no_transaksi }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Created Date</span>
                  <span class="m-list-desc">{{
                    moment(data.header.tanggal_buat).format(
                      getDefaultDateFormat
                    )
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Total</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.mata_uang, data.header.total)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Total Usage</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.mata_uang, data.header.total_pemakaian)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Remaining Balance</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.mata_uang, data.header.total_sisa_saldo)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{
                    data.header.note
                  }}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Usage Details</h4>
              <a-list
                itemLayout="vertical"
                :dataSource="data.detail_invoice"
                :pagination="pagination"
              >
                <a-list-item slot="renderItem" slot-scope="item, indexItem">
                  <a-row :gutter="8">
                    <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                      <a-list-item-meta>
                        <span slot="title">{{
                          item.deskripsi ? item.deskripsi : "Terima Uang Muka"
                        }}</span>
                        <div slot="description" class="margin-remove">
                          <span>{{
                            moment(item.tanggal).format(getDefaultDateFormat)
                          }}</span>
                          <div>
                            <span>{{ item.label }}</span>
                            <h4 class="margin-remove">
                              {{ formatCurrency(data.mata_uang, item.nilai) }}
                            </h4>
                          </div>
                          <a-button v-if="item.lampiran" @click="viewLampDoc(item.lampiran_path)" 
                                class="margin-top" type="dashed">View Document</a-button>
                        </div>
                      </a-list-item-meta>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                      <a-row>
                        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                          <div v-if="item.label!='Debit'">
                            <a-switch
                              :key="
                                'flag_' +
                                  (indexItem +
                                    (pagination.page - 1) * pagination.pageSize)
                              "
                              @change="handleCheckData(item)"
                              v-decorator="[
                                'potential_tax',
                                { rules: [{ required: false }] },
                              ]"
                              :defaultChecked="item.potensial_tax=='1'?true:false"
                              :disabled="loading.savepetenrialtax || data.jenis.toLowerCase() != 'verifikator'"
                            >
                              <template slot="checkedChildren"
                                ><div>
                                  <a-icon type="check-circle-o" /> Potential Tax
                                </div></template
                              >
                              <template slot="unCheckedChildren"
                                ><div>
                                  <a-icon type="minus-circle-o" /> Non Potential
                                  Tax
                                </div></template
                              >
                            </a-switch>
                          </div>
                        </a-col>
                        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                          <div
                            class="m-text-align right"
                            :id="
                              'button_' +
                                (indexItem +
                                  (pagination.page - 1) * pagination.pageSize)
                            "
                            :style="
                              item.potensial_tax=='1'
                                ? 'display:block'
                                : 'display:none'
                            "
                          >
                            <a-tag :color="item.potensial_tax=='1' ? 'green' : 'red'" class="margin-remove"
                            v-if="data.jenis.toLowerCase() == 'verifikator'"
                            >{{
                              item.potensial_tax=='1' ? "Has been submitted" : "Not yet submitted"
                            }}</a-tag>
                          </div>
                        </a-col>
                      </a-row>
                      <div
                        :id="
                          'div_' +
                            (indexItem +
                              (pagination.page - 1) * pagination.pageSize)
                        "
                        :style="
                          item.potensial_tax=='1' ? 'display:block' : 'display:none'
                        "
                      >
                        <a-textarea
                          class="margin-top"
                          :key="
                            'note_' +
                              (indexItem +
                                (pagination.page - 1) * pagination.pageSize)
                          "
                          :id="
                            'note_' +
                              (indexItem +
                                (pagination.page - 1) * pagination.pageSize)
                          "
                          placeholder="Write the note here ... "
                          :rows="2"
                          v-model="
                            data.detail_invoice[
                              indexItem +
                                (pagination.page - 1) * pagination.pageSize
                            ].reason_potensial
                          "
                          :disabled="data.jenis.toLowerCase() != 'verifikator'"
                        />
                        <a-button
                          @click="submitPotentialTax(item)"
                          type="primary"
                          size="small"
                          class="margin-top"
                          icon="save"
                          :disabled="
                            'div_' +
                              (indexItem +
                                (pagination.page - 1) * pagination.pageSize) !=
                              loading.savepetenrialtaxid &&
                              loading.savepetenrialtax
                          "
                          :loading="
                            'div_' +
                              (indexItem +
                                (pagination.page - 1) * pagination.pageSize) ==
                              loading.savepetenrialtaxid &&
                              loading.savepetenrialtax
                          "
                          v-if="data.jenis.toLowerCase() == 'verifikator'"
                        >
                          Submit
                        </a-button>
                      </div>
                    </a-col>
                  </a-row>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <!--<a-button-->
                  <!--@click="historyToggle"-->
                  <!--type="default"-->
                  <!--size="small"-->
                  <!--class="margin-right-small"-->
                  <!--&gt;-->
                  <!--History-->
                  <!--<a-icon type="undo" />-->
                  <!--</a-button>-->
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat - {{ data.user_pembuat.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(data.user_pembuat.tanggal).format(
                          getDefaultDateFormat
                        )
                      }}
                    </h4>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">{{ data.user_pembuat.status }}</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                  :color="
                    workflow.status === 'On Process' ||
                    workflow.status === 'Delivered'
                      ? 'red'
                      : workflow.status === 'Waiting'
                      ? 'grey'
                      : 'green'
                  "
                >
                  <div class="m-timeline-title">
                    {{
                      workflow.actor === null ? workflow.jenis : workflow.actor
                    }}
                    {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                  </div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >
                      {{
                        moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                      }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
          <a-card
            class="margin-top"
            :loading="pageLoading"
            v-if="data.jenis.toLowerCase() === 'verifikator'"
          >
            <div slot="title">Manifest Actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Actions">
                <a-select
                  v-decorator="['aksi', { rules: [{ required: true }] }]"
                >
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                    item.aksi
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleAction"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
      </a-row>
    </div>
    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }}
                {{ history.tlc_to ? "|" + history.tlc_to : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <a-drawer
      title="Security"
      placement="bottom"
      :closable="true"
      @close="onClose"
      :visible="securityVisible"
    >
      <a-form :form="formConfirm">
        <a-form-item label="Password">
          <a-input
            type="password"
            placeholder="Password"
            v-decorator="['password', { rules: [{ required: true }] }]"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleSubmit"
            block
            type="primary"
            html-type="submit"
            >Process</a-button
          >
        </a-form-item>
      </a-form>
    </a-drawer>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Status from "@/components/Status.vue";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "LapManifestBailout",
  props: ["id"],
  components: { Status },
  mixins: [CurrencyFormat],
  data() {
    return {
      visibleHistory: false,
      securityVisible: false,
      pageLoading: true,
      data: {},
      submit: {},
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page:1,
        pageSize: 5,
        size: "small",
      },
      loading: {
        savepetenrialtaxid: "",
        savepetenrialtax: false,
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formConfirm = this.$form.createForm(this);
  },
  created() {
    this.fetchManifest();
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
      }
    },
  },
  computed: {
    ...mapGetters(["getScreen", "getDefaultDateFormat", "getDateTimeFormat"]),
  },
  methods: {
    moment,
    fetchManifest() {
      axios({
        method: "get",
        url: this.$serviceUrl + "Public_manifest/manifest_lap_bailout",
        params: {
          id_manifest: this.id,
        },
      })
        .then((response) => {
          this.data = {
            header: {
              no_lkb: response.data.invoice[0].no_lkb,
              no_transaksi: response.data.invoice[0].no_transaksi,
              tanggal_buat: response.data.invoice[0].tgl_buat,
              total: response.data.invoice[0].saldo || 0,
              total_pemakaian: response.data.invoice[0].total_pemakaian || 0,
              total_sisa_saldo:
                response.data.invoice[0].sisa || 0,
              note: response.data.invoice[0].catatan || ""
            },
            assignee: response.data.assignee,
            jenis: response.data.jenis,
            last_status: response.data.invoice[0].status,
            user_pembuat: {
              tlc: response.data.invoice[0].tlc,
              tanggal: response.data.invoice[0].tgl_buat,
              status: "Created",
            },
            bukti_transfer: response.data.detail_bukti_transfer,
            detail_invoice: response.data.dtl_invoice,
            status: response.data.status_app,
            history: response.data.notifikasi,
            aksi: response.data.aksi,
            mata_uang: response.data.invoice[0].currency,
          };

          for (let i = 0; i < this.data.detail_invoice.length; i++) {
            this.data.detail_invoice[i]["potential_tax"] = this.data.detail_invoice[i].potensial_tax=="1"?true:false;
            this.data.detail_invoice[i]['key'] = i;
          }
          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
          this.$router.go(-1);
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handlePrint() {},
    handleAction() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }
        this.submit = {
          catatan: values.catatan ? values.catatan : "",
          aksi: values.aksi,
        };
        this.securityVisible = true;
      });
    },
    handleSubmit() {
      this.formConfirm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        let postData = new FormData();

        postData.append("id_manifest", this.id);
        postData.append("status", this.submit.aksi);
        postData.append(
          "remark",
          this.submit.catatan !== undefined ? this.submit.catatan : ""
        );
        postData.append("password", values.password);

        axios({
          method: "post",
          url: this.$serviceUrl + "Public_manifest/approval_lap_bailout",
          processData: false,
          data: postData,
        })
          .then((response) => {
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            this.displayMessageValue("error-other", err.response.data.message)
            console.log("error : " + err);
          });
      });
    },
    onClose() {
      this.securityVisible = false;
    },
    handleCheckData(item) {
      let indx = _.findIndex(
        this.data.detail_invoice,
        (el) => el.key == item.key
      );
      this.data.detail_invoice[indx].reason_potensial = "";
      this.data.detail_invoice[indx].potential_tax = !this.data.detail_invoice[
        indx
      ].potential_tax;
      this.data.detail_invoice[indx].potensial_tax = this.data.detail_invoice[indx].potential_tax ? '1' : null;
      if (this.data.detail_invoice[indx].potential_tax) {
        document.getElementById("div_" + item.key).style = "display:block";
        document.getElementById("button_" + item.key).style = "display:block";
      } else {
        document.getElementById("div_" + item.key).style = "display:none";
        document.getElementById("button_" + item.key).style = "display:none";
        document.getElementById("note_" + item.key).value = "";
      }

      if(!this.data.detail_invoice[indx].potential_tax){
        let formData = new FormData();
        formData.append("jenis_transaksi", this.data.detail_invoice[indx].jenis_transaksi);
        formData.append("id_dtl", this.data.detail_invoice[indx].id_dtl);
        formData.append("potential_tax", "0");
        formData.append("note", "");
        this.$store
          .dispatch("axiosStorePublicPost", {
            url: "Public_manifest/tax_potential",
            params: formData,
          })
          .then(() => {
          })
          .catch((err) => {
            console.log("err", err);
            let responses = Object.assign({}, err.response);
            this.displayMessageValue("error", responses);
          });
      }
    },
    submitPotentialTax(item) {
      this.loading.savepetenrialtax = true;
      this.loading.savepetenrialtaxid = "div_" + item.key;

      let items = _.filter(
        this.data.detail_invoice,
        (el) => el.key == item.key
      );

      if (items.length > 0 && items[0].reason_potensial != undefined) {
        let formData = new FormData();
        formData.append("jenis_transaksi", items[0].jenis_transaksi);
        formData.append("id_dtl", items[0].id_dtl);
        formData.append("potential_tax", items[0].potential_tax ? "1" : "0");
        formData.append("note", items[0].reason_potensial);
        this.$store
          .dispatch("axiosStorePublicPost", {
            url: "Public_manifest/tax_potential",
            params: formData,
          })
          .then((res) => {
            let ind = _.findIndex(this.data.detail_invoice, { key: item.key });
            this.data.detail_invoice[ind].id_dtl = res.data.id_dtl;
            this.data.detail_invoice[ind].reason_potensial = res.data.note;
            this.data.detail_invoice[ind].potensial_tax = res.data.potential_tax;
            this.loading.savepetenrialtax = false;
            this.loading.savepetenrialtaxid = "";
          })
          .catch((err) => {
            console.log("err", err);
            this.loading.savepetenrialtax = false;
            this.loading.savepetenrialtaxid = "";
            let responses = Object.assign({}, err.response);
            this.displayMessageValue("error", responses);
          });
      } else {
        this.displayMessageValue(
          "error-other",
          "Data Not Selected or Note is empty!"
        );
        this.loading.savepetenrialtax = false;
        this.loading.savepetenrialtaxid = "";
      }
    },
    viewLampDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    }
  },
};
</script>

<style>
</style> 